export type AboutSkill = {
  id: number;
  title: string;
  src: string;
};

export const ABOUT_SKILLS: AboutSkill[] = [
  { id: 1, src: require("../assets/images/unity.png"), title: "Unity" },
  { id: 2, src: require("../assets/images/c.png"), title: "C#" },
  { id: 3, src: require("../assets/images/arcore.png"), title: "AR Foundation" },
  { id: 4, src: require("../assets/images/blender.png"), title: "Blender" },
  { id: 5, src: require("../assets/images/github.png"), title: "Github" },
  { id: 6, src: require("../assets/images/jira.png"), title: "JIRA" },
  { id: 7, src: require("../assets/images/mr.png"), title: "Mixed Reality" },
  { id: 8, src: require("../assets/images/webar.png"), title: "WebAR" },
  { id: 9, src: require("../assets/images/photon.jpg"), title: "Photon" },
  { id: 10, src: require("../assets/images/mrtk.jpg"), title: "MRTK" },
  { id: 11, src: require("../assets/images/mapbox.jpg"), title: "Mapbox" },
  { id: 12, src: require("../assets/images/rest-api.jpg"), title: "Rest API" },
];
